import { Card, Spinner, StatusIndicator } from '@nike/eds'
import styles from './ShipmentStatusBar.module.css'
import { useCarrier } from '../../../services/CarriersProvider'
import { get } from '../../../common/components/properties/Properties'
import { isHold, isRebooking } from '../ShipmentFlags'

const STATUS_INDICATOR_PADDING = 8

export function ShipmentStatusBar({ shipment }) {
  const [carrier, loading, error] = useCarrier(
    String(get(shipment, 'shipmentVendors.vendorCode')),
    String(get(shipment, 'shipmentVendors.hubCode'))
  )
  return (
    <div id="statusBar" className={styles.statusBar}>
      <Card padding={STATUS_INDICATOR_PADDING}>
        <StatusIndicator
          label="IDP"
          status={shipment.iDPIndicator ? 'success' : 'inactive'}
          size="large"
          className={styles.status}
        />
      </Card>
      <Card padding={STATUS_INDICATOR_PADDING}>
        {loading ? (
          <Spinner size={'medium'}></Spinner>
        ) : carrier ? (
          <StatusIndicator
            label="APL"
            status={carrier.aplIndicator ? 'success' : 'inactive'}
            size="large"
            className={styles.status}
          />
        ) : (
          <span>{error ? 'Error' : 'APL flag not found'}</span>
        )}
      </Card>
      <Card padding={STATUS_INDICATOR_PADDING}>
        <StatusIndicator
          label="Rebooked"
          status={isRebooking(shipment?.rebooking?.rebookingType) ? 'success' : 'inactive'}
          size="large"
          className={styles.status}
        />
      </Card>
      <Card padding={STATUS_INDICATOR_PADDING}>
        <StatusIndicator
          label="Hold"
          status={isHold(shipment?.rebooking?.rebookingType) ? 'success' : 'inactive'}
          size="large"
          className={styles.status}
        />
      </Card>

      <Card padding={STATUS_INDICATOR_PADDING}>
        <StatusIndicator
          label="X-Dock"
          status={shipment?.xDockFlag ? 'success' : 'inactive'}
          size="large"
          className={styles.status}
        />
      </Card>
      <Card padding={STATUS_INDICATOR_PADDING}>
        <StatusIndicator
          label="Export"
          status={shipment.exportIndicator ? 'success' : 'inactive'}
          size="large"
          className={styles.status}
        />
      </Card>
      <Card padding={STATUS_INDICATOR_PADDING}>
        <StatusIndicator
          label="One-time-shipment"
          status={shipment.shipmentShipToAddress?.addressOverrideIndicator ? 'success' : 'inactive'}
          size="large"
          className={styles.status}
        />
      </Card>
    </div>
  )
}
